export default "e142cc6e7e6141d0b4ff08b1015cd0c5.png";